let clientUrl

const clientUrls = {
  production: 'https://quizbee.fun',
  development: 'http://localhost:7165'
}

if (window.location.hostname === 'localhost') {
  clientUrl = clientUrls.development
} else {
  clientUrl = clientUrls.production
}

export default clientUrl